export default [
    {
        path: '/stock-transfer',
        name: 'stock_transfer',
        component: () => import('@src/stock-transfer/stock-transfer.vue'),
        meta: {
            title: 'Zielumlagern',
            role: 'ROLE_STOCK_TRANSFER',
        },
    },
];
